import { useApolloClient } from "@apollo/client";
import React from "react";
import { useChangeContingencyMutation } from "../doc-items/hooks/useDecisionItemMutations.generated.js";

interface Options {
  projectId: string | null;
  docId: string;
}

export type ToggleContingencyFn = (
  itemId: string,
  newValue: boolean | null
) => Promise<void>;

export function useContingencyCheckbox({ projectId, docId }: Options) {
  const client = useApolloClient();
  const [changeContingency] = useChangeContingencyMutation({ client });

  const toggleContingency: ToggleContingencyFn = React.useCallback(
    async (itemId, newValue) => {
      const result = await changeContingency({
        variables: {
          input: {
            projectId,
            docId,
            itemId,
            values: { decisionContingentItemPreselection: newValue },
          },
        },
      });
      if (result.errors?.length) {
        throw new Error(result.errors[0].message);
      }
      if (!result.data) {
        throw new Error("Could not update contingency");
      }
    },
    [changeContingency, projectId, docId]
  );

  return { toggleContingency };
}
